import React from "react";
import styled from "styled-components";
import {TagCardStyled} from "../TagCard";

const SubTagPlentyCard = ({
                              color,
                              id,
                              category,
                              name,
                              handleTag,
                              action = "",
                              className = "",
                              height
                          }) => {

    const data = {id, name, category, color}

    return (
        <Card
            onClick={action === "add" ? () => handleTag(data) : null}
            style={{backgroundColor: color, padding: "10px"}}
            className={className}
        >
            <div>
                <p style={{fontSize: height ?? "14px"}}>{category ? `${category} / ` : null} {name}</p>
            </div>
            {action === "remove" ?
                <div className={'flex-row ai-center'} onClick={() => handleTag(data)}>
                    <svg xmlns="http://www.w3.org/2000/svg" height={height ?? "14px"} viewBox="0 0 24 24" width="24px"
                         fill="#FAFAFA">
                        <path d="M0 0h24v24H0V0z" fill="none"/>
                        <path
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
                    </svg>
                </div>
                :
                ""
            }
        </Card>
    )
}

export default SubTagPlentyCard;

const Card = styled(TagCardStyled)`
  display: flex;
  align-items: center;
  min-width: auto;
  width: auto;
  white-space: nowrap;
  border-radius: 3px;
  height: 18px;
  font-size: 14px;
  text-align: left;

  h4 {
    color: inherit;
  }
`